import { Variant } from '../types'

type Constituent = {
  isConstituentProduct: boolean
  externalLinkedUrl: string | null
}

export interface TransformedVariant extends Variant {
  enableAddToBasket: boolean
  constituentProduct: Constituent
}

const DEFAULT_CONSTITUENT = {
  isConstituentProduct: false,
  externalLinkedUrl: null,
}

const findProductContent = (content, key: string) => {
  return content.find((item) => item.key === key)?.value?.stringValue
}

const extractConstituentdata = (content): Constituent => {
  if (!content) {
    return DEFAULT_CONSTITUENT
  }

  const externalLinkedUrl = findProductContent(content, 'externalLinkedUrl')

  if (externalLinkedUrl) {
    return {
      externalLinkedUrl,
      isConstituentProduct: true,
    }
  }

  return DEFAULT_CONSTITUENT
}

// @TODO: REBUILD-8622
export const variant = (variant, enableAddToBasket): TransformedVariant => {
  const constituentProduct = extractConstituentdata(variant.content)

  return {
    ...variant,
    constituentProduct,
    enableAddToBasket,
  }
}
